(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    
  const loadDeferredApps = async (root) => {
    if (root.dataset.nuoneoDeferredAppsState) return;
    const template = root.querySelector('[data-nuoneo-deferred-apps-template]');
    if (!template) return;

    root.dataset.nuoneoDeferredAppsState = 'loading';
    const fragment = template.content.cloneNode(true);
    const scripts = Array.from(fragment.querySelectorAll('script'));

    scripts.forEach((script, index) => {
      const marker = document.createElement('span');
      marker.hidden = true;
      marker.dataset.nuoneoDeferredScript = String(index);
      script.replaceWith(marker);
    });

    root.replaceChildren(fragment);

    for (const [index, original] of scripts.entries()) {
      const marker = root.querySelector(`[data-nuoneo-deferred-script="${index}"]`);
      if (!marker) continue;
      const executable = document.createElement('script');

      for (const attribute of original.attributes) {
        executable.setAttribute(attribute.name, attribute.value);
      }

      executable.textContent = original.textContent;

      if (original.src) {
        await new Promise((resolve) => {
          executable.addEventListener('load', resolve, { once: true });
          executable.addEventListener('error', resolve, { once: true });
          marker.replaceWith(executable);
        });
      } else {
        marker.replaceWith(executable);
      }
    }

    root.dataset.nuoneoDeferredAppsState = 'loaded';
  };

  const deferredAppRoots = document.querySelectorAll('[data-nuoneo-deferred-apps]');

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          observer.unobserve(entry.target);
          loadDeferredApps(entry.target);
        }
      },
      { rootMargin: '400px 0px' }
    );

    deferredAppRoots.forEach((root) => observer.observe(root));
  } else {
    deferredAppRoots.forEach((root) => loadDeferredApps(root));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const unitPattern = /(\d+(?:[.,]\d+)?)\s*(g|st(?:ück)?|pcs?|pieces?|capsules?)(?=\s|$|[(/-])/i;

    const getUnits = (text) => {
      const match = String(text || '').match(unitPattern);
      if (!match) return null;

      return {
        amount: Number(match[1].replace(',', '.')),
        type: match[2].toLowerCase().startsWith('g') ? 'g' : 'stk',
      };
    };

    const initialize = (scope = document) => {
      scope.querySelectorAll('product-info[data-variant-savings]').forEach((root) => {
        if (root.dataset.variantSavingsInitialized === 'true') return;

        const dataElement = root.querySelector('[data-variant-savings-variants]');
        if (!dataElement) return;

        let variants;
        try {
          variants = JSON.parse(dataElement.textContent);
        } catch {
          return;
        }

        const referenceVariant = variants.find((variant) => getUnits(variant.title));
        const referenceUnits = getUnits(referenceVariant?.title);
        if (!referenceVariant || !referenceUnits?.amount) return;

        const referencePricePerUnit = referenceVariant.price / referenceUnits.amount;
        const savingsLabel = root.dataset.variantSavingsLabel;

        const renderBadges = () => {
          root.querySelectorAll('.m-variant-discount-badge').forEach((badge) => badge.remove());

          root.querySelectorAll('.m-product-option--node__label[for]').forEach((label) => {
            const input = root.querySelector(`#${CSS.escape(label.htmlFor)}`);
            const optionValue = input?.value?.trim();
            if (!optionValue) return;

            const variant = variants.find((item) =>
              item.options.some((option) => option.toLowerCase() === optionValue.toLowerCase())
            );
            const units = getUnits(optionValue) || getUnits(variant?.title);
            if (!variant || !units?.amount || units.type !== referenceUnits.type) return;

            const pricePerUnit = variant.price / units.amount;
            const savings = Math.round((1 - pricePerUnit / referencePricePerUnit) * 100);
            if (savings <= 0) return;

            const badge = document.createElement('span');
            badge.className = 'm-variant-discount-badge';
            badge.textContent = `${savings}% ${savingsLabel}`;
            label.appendChild(badge);
          });
        };

        root.dataset.variantSavingsInitialized = 'true';
        root.renderVariantSavings = renderBadges;
        root.addEventListener('change', (event) => {
          if (event.target.matches('.m-product-option__input')) {
            requestAnimationFrame(renderBadges);
          }
        });
        renderBadges();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize());
    } else {
      initialize();
    }

    document.addEventListener('variant:changed', () => {
      document.querySelectorAll('product-info[data-variant-savings]').forEach((root) => {
        root.renderVariantSavings?.();
      });
    });

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
